import Promise from 'bluebird';
import URI from 'urijs';
import { downloadifyBlob } from './downloadify';

/**
 * download
 * When to use:
 *   the resource to download is on the same origin, or with CORS header
 * Why to use:
 *   If a resource has header Content-Type: text/csv, Safari would open a new tab for the data
 *   instead of download it. This approach aligned download to downloadify which works fine.
 * @param {string} url - url to download
 * @param {string} fileName - name of the resource to download
 * @returns {promise} - resolve when download finishes
 */
export function download(url, fileName = URI(url).filename()) {
  return new Promise((resolve) => {
    const xhr = new XMLHttpRequest();
    xhr.open('GET', url);
    xhr.responseType = 'blob';
    xhr.onload = () => {
      downloadifyBlob(xhr.response, fileName);
      resolve();
    };
    xhr.send();
  });
}
